import React from 'react';

function Footer() {
  return (
    <footer className="text-white text-center fw-bold">JIMMY BOSTROEM</footer>
  );
}

export default Footer;
